import { AxiosPromise }     from 'axios'
import { DealernetApi }     from "./DealernetApi";
import {
    IPartAddRequestDto,
    IPartSearchRequest,
    IPartQuoteRequestDto,
    Tuple }          from "@/types"

export class PartSearchService {

    public static async PartSearch(data: IPartSearchRequest): Promise<any> {
        const response = await DealernetApi.client().post("/PartSearch/PartSearch", data );
        return response;
    }

    public static PartAddRequest(
        data: IPartAddRequestDto
    ): AxiosPromise<boolean> {
        return DealernetApi.client().request({
            method: "post",
            url: `/PartSearch/PartAddRequest`,
            data
        });
    }

    public static PartQuoteRequest(
        data: IPartQuoteRequestDto
    ): AxiosPromise<Tuple<boolean, string>> {
        return DealernetApi.client().request({
            method: "post",
            url: '/PartSearch/PartQuoteRequest',
            data
        });
    }
}